<footer class="site-footer" *ngIf="!isErrorPage()">
  <div class="footer-inner">

    <!-- Sinistra: Privacy -->
    <div class="footer-left">
      <a href="#" class="footer-link" target="_self">Privacy Policy</a>
      <span class="footer-sep">·</span>
      <a href="#" class="footer-link" target="_self">Cookie Policy</a>
    </div>

    <!-- Destra: Powered by -->
    <div class="footer-right">
      <span class="footer-text">Powered by</span>
      <a
        href="https://bycom.it"
        target="_blank"
        rel="noopener noreferrer"
        class="footer-brand"
      >Bycom</a>
    </div>

  </div>
</footer>

<!-- Avatar flottante (decorativo) -->
<img
  *ngIf="!isErrorPage() && showAvatar"
  [src]="avatarUrl"
  [title]="tenant?.name || ''"
  class="gianna-floating"
  (error)="$any($event.target).src = errorAvatarUrl"
/>
